export const TRANSCRIPTION_AUDIO_MIME_TYPE = "audio/webm;codecs=opus";

/** Recording bitrate (~64 kbps); used by MediaRecorder and duration estimation. */
export const TRANSCRIPTION_RECORDING_BITRATE_BPS = 64_000;

/** WebM AppendBlobs don't write duration to the container header. */
export const TRANSCRIPTION_RECORDING_BYTES_PER_SECOND = TRANSCRIPTION_RECORDING_BITRATE_BPS / 8;

export const TRANSCRIPTION_CHUNK_INTERVAL_MS = 2_000;

export const TRANSCRIPTION_SAS_TOKEN_LIFETIME_MS = 60 * 60 * 1_000;
export const TRANSCRIPTION_SAS_TOKEN_REFRESH_BEFORE_EXPIRY_MS = 10 * 60 * 1_000;
export const TRANSCRIPTION_SAS_TOKEN_REFRESH_INTERVAL_MS =
    TRANSCRIPTION_SAS_TOKEN_LIFETIME_MS - TRANSCRIPTION_SAS_TOKEN_REFRESH_BEFORE_EXPIRY_MS;

export const TRANSCRIPTION_CHUNK_UPLOAD_MAX_RETRIES = 6;
export const TRANSCRIPTION_CHUNK_UPLOAD_RETRY_BASE_MS = 1_000;
export const TRANSCRIPTION_CHUNK_UPLOAD_MAX_BACKOFF_MS = 16_000;

export const TRANSCRIPTION_CHUNK_QUEUE_MAX_BYTES = 8 * 1024 * 1024;

export const TRANSCRIPTION_SEGMENT_ROLLOVER_MS = 30 * 60 * 1_000;
export const TRANSCRIPTION_SEGMENT_MAX_BYTES = 128 * 1024 * 1024;
export const TRANSCRIPTION_SEGMENT_ROLLOVER_RETRY_MS = 10_000;

export const TRANSCRIPTION_UPLOAD_DRAIN_TIMEOUT_MS = 15_000;

export const TRANSCRIPTION_RECORDER_FLUSH_TIMEOUT_MS = 250;

export const TRANSCRIPTION_MAX_RECORDING_MS = 180 * 60 * 1_000;
export const TRANSCRIPTION_MAX_RECORDING_WARNING_MS = 10 * 60 * 1_000;

/** Level (0–100) at or below which a metering tick counts as silence. */
export const TRANSCRIPTION_SILENCE_LEVEL_THRESHOLD = 1;
/** Sustained silence before warning the user the mic isn't capturing sound — long enough that normal speech pauses don't trigger it. */
export const TRANSCRIPTION_SILENCE_DURATION_MS = 8_000;

export const TRANSCRIPTION_FEATURE = "Health.Features.Transcriptions";
export const TRANSCRIPTION_MONTHLY_LIMIT_FEATURE = `${TRANSCRIPTION_FEATURE}.MonthlyLimit`;
export const ATTENDANCE_TRANSCRIPTION_SETTING = "Health.Attendance.Transcriptions";

/** Release/kill-switch flag gating the whole `/settings/transcription` page (route + nav), distinct from
 *  the feature setting above. Ships off; flipped on globally or per-tenant at rollout. */
export const TRANSCRIPTION_SETTINGS_PAGE_SETTING = "Health.Settings.TranscriptionPage";

/** Free trial size: exactly 3 transcriptions/month, seeded on the v1 editions (EditionDefinition.cs).
 *  Paid packs (30/100/unlimited) are additive over this base, so a paying tenant's limit is never exactly 3 —
 *  which is what lets `limit === TRANSCRIPTION_FREE_TRIAL_LIMIT` distinguish the trial from a purchased pack. */
export const TRANSCRIPTION_FREE_TRIAL_LIMIT = 3;

export interface AppointmentTranscriptionForResume {
    transcriptionId: number;
    status: number;
}

export interface TranscriptionStartedEvent {
    transcriptionId: number;
    initialOffsetMs?: number;
}

export interface AddToMedicalRecordRequest {
    content: string;
    /**
     * The host publishes the note and reports the outcome: true on success, false on failure.
     * Hosts MUST call this exactly once on every path (including early returns) — the view keeps
     * its "add" button disabled/loading until it fires, so a missed call leaves the button stuck.
     */
    onResult: (success: boolean) => void;
}
